export default "__VITE_ASSET__BpH_CNI6__"